import { render, staticRenderFns } from "./previewSCCL.vue?vue&type=template&id=85cf8d30&scoped=true&lang=html&"
import script from "./previewSCCL.vue?vue&type=script&lang=js&"
export * from "./previewSCCL.vue?vue&type=script&lang=js&"
import style0 from "./previewSCCL.vue?vue&type=style&index=0&id=85cf8d30&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85cf8d30",
  null
  
)

export default component.exports